<template>
	<v-text-field
		xxclass="px-1 py-1"
		v-model.number="minutes"
		density="compact"
		hide-details="auto"
		control-variant="split"
		@update:modelValue="toTime"
		style="width: 6rem; max-width: 6rem"
	>
		<template #append-inner>分</template>
	</v-text-field>

	<v-number-input
		xxclass="px-1 py-1"
		hide-details="auto"
		density="compact"
		v-model.number="seconds"
		inset
		:max="59"
		:min="0"
		control-variant="split"
		@update:modelValue="toTime"
		style="width: 10rem; max-width: 10rem"
	>
		<template #append-inner>秒</template>
	</v-number-input>
</template>

<script>
export default {
	name: 'TimeInput',
	props: {
		modelValue: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			value: 0,
			minutes: 0,
			seconds: 0
		}
	},
	mounted() {
		this.value = this.modelValue
		this.fromTime()
	},
	watch: {
		modelValue(newVal) {
			this.value = newVal
			this.fromTime()
		}
	},
	methods: {
		toTime() {
			this.value = this.minutes * 60 + this.seconds
			this.$emit('update:modelValue', this.value)
		},
		fromTime() {
			this.minutes = Math.floor(this.value / 60)
			this.seconds = this.value % 60
		}
	}
}
</script>
